<template>
  <div>
    <div class="row center-xs">
      <span
        class="col-xs-12 center-xs pl-subheading"
        style="margin-bottom: 40px; font-size: 40px; color: black"
      >
        I am a...
      </span>
    </div>
    <div class="row center-xs">
      <pl-button
        @click.native="emitTeacher"
        class="col-xs"
        style="font-size: 28px; color: black"
      >
        <img
          src="/static/teacher_icons/teacher_sign_up_black.svg"
          alt=""
          style="padding-left: 10px; padding-bottom: 10px"
        />
        <br />
        TEACHER
      </pl-button>
      <div
        class="vertical-line"
        style="margin-left: 30px; margin-right: 30px"
      />
      <pl-button
        @click.native="emitStudent"
        class="col-xs"
        style="font-size: 28px; color: black"
      >
        <img
          src="/static/student_icons/student_sign_up_black.svg"
          alt=""
          style="padding-left: 10px; padding-bottom: 10px"
        />
        <br />
        STUDENT
      </pl-button>
    </div>
    <div class="row center-xs">
      <div class="col-xs-7 pt4">
        <span class="b">Note: </span>
        <span class="i">
          If you are a teacher and joining a discussion in a PD session, you
          should still create a teacher account.
        </span>
      </div>
    </div>
  </div>
</template>
<!--
  JAVASCRIPT
-->
<script lang="babel">
  import store from 'store';

  export default {
    data() {
      return {
      };
    },
    methods: {
      emitTeacher() {
        store.dispatch('analytics', 'teacher verbal discussion - teacher registers');
        this.$emit('role', 'teacher');
      },
      emitStudent() {
        store.dispatch('analytics', 'student verbal discussion - student registers');
        this.$emit('role', 'student');
      },
    },
  };
</script>
<!--
  CSS
-->
<style scoped lang="stylus">
  .vertical-line
    width: 2px;
    background-color: black;
    float: left;
    height: 20em;
</style>



// WEBPACK FOOTER //
// chooseRole.vue?6e96dac9